module.exports = __webpack_public_path__ + "static/media/language_front.71d62fa8.png";